/**
 * @typedef {Object} QuickLink
 * @property {number} index - The position of the quick link in the list.
 * @property {string} title - The display name of the quick link.
 * @property {string} href - The URL path the quick link points to.
 * @property {boolean} hidden - Whether the quick link is hidden.
 * @property {boolean} enabled - Whether the quick link is enabled.
 */

/**
 * @type {QuickLink[]}
 * @description Default quick links for the application.
 */
/* eslint-disable object-curly-newline */
// Key must not change while we use the constant as source
const defaultQuickLinks = [
  {
    key: 'PurchaseHistory',
    index: 0,
    title: 'Purchase History',
    href: '/myaccount/purchase-history',
    hidden: false,
    enabled: true
  },
  {
    key: 'Lists',
    index: 1,
    title: 'Lists',
    href: '/list/view/summary',
    hidden: false,
    enabled: true
  },
  {
    key: 'Projects',
    index: 2,
    title: 'Projects',
    href: '/projects',
    hidden: false,
    enabled: false
  },
  {
    key: 'Quotes',
    index: 3,
    title: 'Quotes',
    href: '/quote/list',
    hidden: false,
    enabled: true
  },
  {
    key: 'RewardsHub',
    index: 4,
    title: 'Rewards Hub',
    href: '/myaccount/proXtraRewards',
    hidden: false,
    enabled: true
  },
  // eslint-disable-next-line max-len
  {
    key: 'PaintPurchaseHistory',
    index: 5,
    title: 'Paint Purchase History',
    href: '/myaccount/paintPurchaseHistory',
    hidden: false,
    enabled: true
  },
  {
    key: 'BuyItAgain',
    index: 6,
    title: 'Buy It Again',
    href: '/buyitagain',
    hidden: false,
    enabled: true
  },
  {
    key: 'Addresses',
    index: 7,
    title: 'Addresses',
    href: '/myaccount/addresses',
    hidden: false,
    enabled: true
  },
  {
    key: 'AccountDashboard',
    index: 8,
    title: 'Account Dashboard',
    href: '/myaccount/dashboard',
    hidden: false,
    enabled: true
  },
  {
    key: 'CardsAccounts',
    index: 9,
    title: 'Cards & Accounts',
    href: '/myaccount/payments',
    hidden: false,
    enabled: true
  }
];
Object.freeze(defaultQuickLinks);

// Shared with Header and other experiences -- do not remove/modify key
export const ACCOUNT_BENEFITS_STORAGE_KEY = 'header_account_benefit_tags_shared_';

export {
  defaultQuickLinks
};
